import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.korenet');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';


@Component({
    selector: 'wiz-layout-korenet',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.korenet/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.writing-mode-vertical {
  writing-mode: vertical-rl;
  text-orientation: upright;
  letter-spacing: 2px;
}

.viz-overlay-panel {
  width: calc(100% - 40px);
  height: calc(100% - 60px);
  max-width: 1500px;
  max-height: 940px;
  min-width: 0;
}

@media (max-width: 1280px) {
  .viz-overlay-panel {
    width: calc(100% - 32px);
    height: calc(100% - 48px);
    max-width: 1280px;
    max-height: 900px;
  }
}
@media (max-width: 1024px) {
  .viz-overlay-panel {
    width: calc(100% - 20px);
    height: calc(100% - 36px);
  }
}
@media (max-width: 640px) {
  .viz-overlay-panel {
    width: calc(100% - 12px);
    height: calc(100% - 24px);
  }
}
@keyframes vizFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.animate-viz-in {
  animation: vizFadeIn 0.2s ease-out;
}

.viz-result-tabs {
  background: #fff;
}

.viz-result-tabs-scroll {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 9px 16px 8px;
  scrollbar-width: thin;
}
.viz-result-tabs-scroll::-webkit-scrollbar {
  height: 4px;
}
.viz-result-tabs-scroll::-webkit-scrollbar-thumb {
  background: #d4d4d8;
  border-radius: 999px;
}

.viz-result-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  max-width: 260px;
  height: 30px;
  padding: 0 4px 0 0;
  border: 1px solid #e4e4e7;
  border-radius: 7px;
  background: #fff;
  color: #52525b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  overflow: hidden;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}
.viz-result-tab:hover {
  border-color: rgba(74, 111, 216, 0.35);
  background: rgba(74, 111, 216, 0.06);
  color: #3D5DB8;
}

.viz-result-tab-select {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0 6px 0 10px;
  color: inherit;
  font: inherit;
  cursor: pointer;
}
.viz-result-tab-select span {
  min-width: 0;
}
.viz-result-tab-select:focus-visible {
  outline: 2px solid rgba(74, 111, 216, 0.45);
  outline-offset: -2px;
}

.viz-result-tab--active {
  border-color: rgba(74, 111, 216, 0.45);
  background: rgba(74, 111, 216, 0.1);
  color: #27489f;
  box-shadow: inset 0 -2px 0 #4A6FD8;
}

.viz-result-tab-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  border-radius: 5px;
  color: #a1a1aa;
  transition: color 0.15s ease, background 0.15s ease;
}
.viz-result-tab-close:hover {
  background: rgba(24, 24, 27, 0.08);
  color: #3f3f46;
}
.viz-result-tab-close:focus-visible {
  outline: 2px solid rgba(74, 111, 216, 0.45);
  outline-offset: 1px;
}

.viz-result-tab--active .viz-result-tab-close {
  color: #4A6FD8;
}
.viz-result-tab--active .viz-result-tab-close:hover {
  background: rgba(74, 111, 216, 0.16);
  color: #27489f;
}

.result-content-wrapper h1, .result-content-wrapper h2, .result-content-wrapper h3 {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #18181b;
}
.result-content-wrapper h1 {
  font-size: 1rem;
}
.result-content-wrapper h2 {
  font-size: 0.875rem;
}
.result-content-wrapper h3 {
  font-size: 0.8125rem;
}
.result-content-wrapper p {
  margin-bottom: 0.5rem;
  line-height: 1.6;
}
.result-content-wrapper table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
  margin-bottom: 0.75rem;
}
.result-content-wrapper th, .result-content-wrapper td {
  padding: 0.375rem 0.5rem;
  border: 1px solid #e5e7eb;
  text-align: left;
}
.result-content-wrapper th {
  background: #f9fafb;
  font-weight: 600;
}
.result-content-wrapper ul, .result-content-wrapper ol {
  padding-left: 1.25rem;
  margin-bottom: 0.5rem;
}
.result-content-wrapper li {
  margin-bottom: 0.25rem;
}`],
})
export class LayoutKorenetComponent implements OnInit, OnDestroy {
    public isHome: boolean = (() => {
        const p = location.pathname;
        return p === '/' || p === '/signup';
    })();

    public isAdmin: boolean = false;
    public chatbotOpen: boolean = false;
    public generatedResults: any[] = [];
    public resultPage: number = 0;
    public overlayOpen: boolean = false;
    public overlayWidth: number = 560;

    private panelToggleHandler: any;
    private resultHandler: any;
    private resultUpdateHandler: any;
    private agentResultHandler: any;
    private switchTabHandler: any;
    private clearAllHandler: any;
    private sessionsChangedHandler: any;

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( DomSanitizer    )         private sanitizer: DomSanitizer    ) { }

    public async ngOnInit() {
        await this.service.init();
        this.checkRoute();
        this.router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe(() => {
                const wasHome = this.isHome;
                this.checkRoute();
                // 페이지 이동 시 시각화 오버레이 닫기
                this.overlayOpen = false;
                if (this.isHome && !wasHome && this.chatbotOpen) {
                    this.chatbotOpen = false;
                    window.dispatchEvent(new CustomEvent('chatbot-force-close'));
                }
                this.service.render();
            });

        this.panelToggleHandler = (e: CustomEvent) => {
            this.chatbotOpen = e.detail?.open || false;
            if (!this.chatbotOpen) this.overlayOpen = false;
            this.service.render();
        };
        window.addEventListener('chatbot-panel-toggle', this.panelToggleHandler);

        this.resultHandler = (e: CustomEvent) => {
            const html = e.detail?.html || '';
            if (html) {
                const preparedHtml = this.prepareVisualizationHtml(html);
                const parser = new DOMParser();
                const doc = parser.parseFromString(preparedHtml, 'text/html');
                const h1 = doc.querySelector('h1, h2, h3');
                const title = h1?.textContent?.trim() || '';
                const blob = new Blob([preparedHtml], { type: 'text/html' });
                const iframeObjectUrl = URL.createObjectURL(blob);
                const summary = e.detail?.summary || '';
                const item: any = {
                    id: e.detail?.resultId || ('r-' + Date.now()),
                    rawHtml: preparedHtml,
                    timestamp: e.detail?.timestamp || Date.now(),
                    title: e.detail?.title || title,
                    summary,
                    tabSummary: this.summarizeResultSummary(summary, e.detail?.title || title),
                    iframeObjectUrl,
                    iframeSrc: this.sanitizer.bypassSecurityTrustResourceUrl(iframeObjectUrl)
                };
                this.generatedResults.unshift(item);
                this.resultPage = 0;
                this.overlayOpen = true;
                this.service.render();
            }
        };
        window.addEventListener('chatbot-generated-result', this.resultHandler);

        this.resultUpdateHandler = (e: CustomEvent) => {
            const resultId = e.detail?.resultId || '';
            const summary = e.detail?.summary || '';
            if (!resultId || !summary) return;

            const item = this.generatedResults.find((result: any) => result.id === resultId);
            if (!item) return;

            item.summary = summary;
            item.tabSummary = this.summarizeResultSummary(summary, item.title || '');
            this.service.render();
        };
        window.addEventListener('chatbot-generated-result-update', this.resultUpdateHandler);

        this.clearAllHandler = () => {
            this.revokeAllBlobUrls();
            this.generatedResults = [];
            this.resultPage = 0;
            this.overlayOpen = false;
            this.service.render();
        };
        window.addEventListener('chatbot-clear-all', this.clearAllHandler);

        this.sessionsChangedHandler = () => { };
        window.addEventListener('chatbot-sessions-changed', this.sessionsChangedHandler);

        this.agentResultHandler = (e: CustomEvent) => {
            const ids = e.detail?.ids || [];
            if (ids.length > 0) {
                const path = location.pathname;
                if (!path.startsWith('/researcher/') && path !== '/search') {
                    const idsParam = ids.join(',');
                    this.router.navigate(['/search'], { queryParams: { tab: 'researcher', agent_ids: idsParam } });
                }
            }
        };
        window.addEventListener('chatbot-agent-results', this.agentResultHandler);

        // 시각화 결과 보기 → 오버레이 열기
        this.switchTabHandler = async (e: CustomEvent) => {
            const tab = e.detail?.tab;
            const targetPage = e.detail?.resultPage;
            const resultId = e.detail?.resultId;
            if (tab === 'results') {
                if (resultId) {
                    const matchedPage = this.generatedResults.findIndex((item: any) => item.id === resultId);
                    if (matchedPage >= 0) {
                        this.resultPage = matchedPage;
                    } else if (typeof targetPage === 'number') {
                        this.resultPage = targetPage;
                    } else {
                        this.resultPage = 0;
                    }
                } else if (typeof targetPage === 'number') {
                    this.resultPage = targetPage;
                }
                this.overlayOpen = this.generatedResults.length > 0;
            }
            await this.service.render();
        };
        window.addEventListener('chatbot-switch-tab', this.switchTabHandler);
    }

    ngOnDestroy() {
        if (this.panelToggleHandler) window.removeEventListener('chatbot-panel-toggle', this.panelToggleHandler);
        if (this.resultHandler) window.removeEventListener('chatbot-generated-result', this.resultHandler);
        if (this.resultUpdateHandler) window.removeEventListener('chatbot-generated-result-update', this.resultUpdateHandler);
        if (this.agentResultHandler) window.removeEventListener('chatbot-agent-results', this.agentResultHandler);
        if (this.switchTabHandler) window.removeEventListener('chatbot-switch-tab', this.switchTabHandler);
        if (this.clearAllHandler) window.removeEventListener('chatbot-clear-all', this.clearAllHandler);
        if (this.sessionsChangedHandler) window.removeEventListener('chatbot-sessions-changed', this.sessionsChangedHandler);
        this.revokeAllBlobUrls();
    }

    private checkRoute() {
        const path = location.pathname;
        this.isHome = path === '/' || path === '/signup';
        this.isAdmin = path.startsWith('/admin');
    }

    public toggleOverlay() {
        this.overlayOpen = !this.overlayOpen;
        this.service.render();
    }

    public closeOverlay() {
        this.overlayOpen = false;
        this.service.render();
    }

    public collapseOverlay() {
        this.overlayOpen = false;
        this.service.render();
    }

    public expandOverlay() {
        this.overlayOpen = true;
        this.service.render();
    }

    public downloadResultHtml(index: number) {
        const item = this.generatedResults[index];
        if (!item?.rawHtml) return;
        const blob = new Blob([item.rawHtml], { type: 'text/html;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = (item.title || 'visualization') + '.html';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    public openResultNewWindow(index: number) {
        const item = this.generatedResults[index];
        if (!item?.rawHtml) return;
        const win = window.open('', '_blank');
        if (!win) return;
        win.document.write(item.rawHtml);
        win.document.close();
    }

    public async goResultPage(page: number) {
        if (page < 0 || page >= this.generatedResults.length) return;
        this.resultPage = page;
        await this.service.render();
    }

    public async removeResult(index: number, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (index < 0 || index >= this.generatedResults.length) return;

        const [removed] = this.generatedResults.splice(index, 1);
        this.revokeResultBlobUrl(removed);

        if (this.generatedResults.length === 0) {
            this.resultPage = 0;
            this.overlayOpen = false;
        } else if (this.resultPage >= this.generatedResults.length) {
            this.resultPage = this.generatedResults.length - 1;
        } else if (index < this.resultPage) {
            this.resultPage -= 1;
        }

        await this.service.render();
    }

    private prepareVisualizationHtml(html: string): string {
        const source = (html || '').trim();
        if (!source || source.includes('wiz-viz-frame-compact')) return source;

        const style = [
            '<style id="wiz-viz-frame-compact">',
            'html,body{margin:0!important;width:100%;max-width:100%;overflow-x:hidden;}',
            'body{padding:8px!important;background:#fdfcfb;}',
            '.viz-shell{margin:0!important;padding:0!important;min-height:auto!important;}',
            '.viz-grid{gap:14px!important;align-content:start!important;margin:0!important;padding:0!important;}',
            '.viz-card,.chart-card,[class*="card"]{gap:12px!important;padding:16px!important;}',
            '.viz-grid>:empty,.viz-card:empty,.chart-card:empty{display:none!important;}',
            'img,svg,canvas{max-width:100%!important;}',
            '</style>'
        ].join('');

        const script = [
            '<script id="wiz-viz-frame-compact-script">(function(){',
            'if(window.wizVizFrameCompact)return;window.wizVizFrameCompact=1;',
            'function txt(e){return((e.textContent||"").replace(/\\s+/g,"")).trim()}',
            'function media(e){return !!e.querySelector("canvas,svg,img,table,video,iframe")}',
            'function blank(e){return !media(e)&&!txt(e)}',
            'function run(){',
            'document.querySelectorAll(".viz-card,.chart-card,section,[class*=card],[class*=summary],[class*=hero]").forEach(function(e){if(blank(e))e.remove()});',
            'document.querySelectorAll("div,section,article,header").forEach(function(e){if(!e.isConnected||!blank(e))return;var s=getComputedStyle(e);var h=parseFloat(s.height)||0,mh=parseFloat(s.minHeight)||0,pt=parseFloat(s.paddingTop)||0,mt=parseFloat(s.marginTop)||0;if(h>80||mh>80||pt>32||mt>32)e.remove()});',
            'document.querySelectorAll("img").forEach(function(e){if(e.dataset.wizRenderGuard)return;e.dataset.wizRenderGuard="1";e.addEventListener("error",function(){e.style.display="none"})});',
            'if(!window.Chart){document.querySelectorAll(".chart-wrap canvas,[class*=chart-container] canvas").forEach(function(c){var p=c.parentElement;if(!p||p.querySelector(".viz-render-fallback"))return;var d=document.createElement("div");d.className="viz-render-fallback";d.style.cssText="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;text-align:center;padding:16px;color:#64748b;font-size:12px;line-height:1.5;background:#f8fafc;border:1px dashed #cbd5e1;border-radius:10px";d.textContent="차트 라이브러리 로딩을 확인할 수 없습니다.";p.appendChild(d)})}',
            'document.documentElement.style.margin="0";document.body.style.margin="0";document.body.style.padding="8px"',
            '}',
            'if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",run);else run();',
            'window.addEventListener("load",function(){setTimeout(run,80);setTimeout(run,400)});',
            '})();</script>'
        ].join('');

        return this.injectVisualizationStyle(this.injectVisualizationBodyScript(source, script), style);
    }

    private injectVisualizationStyle(html: string, style: string): string {
        const lower = html.toLowerCase();
        if (lower.includes('</head>')) {
            const index = lower.indexOf('</head>');
            return html.slice(0, index) + style + html.slice(index);
        }
        if (lower.includes('<body')) {
            const bodyIndex = lower.indexOf('<body');
            const closeIndex = html.indexOf('>', bodyIndex) + 1;
            return html.slice(0, closeIndex) + style + html.slice(closeIndex);
        }
        return style + html;
    }

    private injectVisualizationBodyScript(html: string, script: string): string {
        const lower = html.toLowerCase();
        if (lower.includes('</body>')) {
            const index = lower.lastIndexOf('</body>');
            return html.slice(0, index) + script + html.slice(index);
        }
        return html + script;
    }

    private summarizeResultSummary(summary: string, title: string = ''): string {
        const source = (summary || title || '').replace(/\s+/g, ' ').trim();
        if (!source) return '시각화 결과';

        const firstSentence = source.split(/[.!?。？！]/)[0]?.trim() || source;
        const limit = 34;
        if (firstSentence.length <= limit) return firstSentence;

        const words = firstSentence.split(' ');
        let label = '';
        for (const word of words) {
            const next = label ? `${label} ${word}` : word;
            if (next.length > limit) break;
            label = next;
        }

        if (!label) label = firstSentence.slice(0, limit);
        return `${label}...`;
    }

    private revokeAllBlobUrls() {
        this.generatedResults.forEach(item => {
            this.revokeResultBlobUrl(item);
        });
    }

    private revokeResultBlobUrl(item: any) {
        const url = item?.iframeObjectUrl;
        if (typeof url !== 'string') return;
        try { URL.revokeObjectURL(url); } catch {}
    }
}

export default LayoutKorenetComponent;